/* eslint-disable @typescript-eslint/no-unused-vars */
import { lazy } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import PrivateRoute from "./core/components/PrivateRoute";

// Admin
const Admin = lazy(() => import("./admin/pages/Admin"));
const Dashboard = lazy(() => import("./admin/pages/Dashboard"));
const Faq = lazy(() => import("./admin/pages/Faq"));
const HelpCenter = lazy(() => import("./admin/pages/HelpCenter"));
// const Home = lazy(() => import("./admin/pages/Home"));
const Search = lazy(() => import("./admin/pages/Search"));
const Overview = lazy(() => import("./admin/pages/Overview"));
const Profile = lazy(() => import("./admin/pages/Profile"));
const ProfileActivity = lazy(() => import("./admin/pages/ProfileActivity"));
const ProfileInformation = lazy(
  () => import("./admin/pages/ProfileInformation")
);
const ProfilePassword = lazy(() => import("./admin/pages/ProfilePassword"));

// Auth
const ForgotPassword = lazy(() => import("./auth/pages/ForgotPassword"));
const ForgotPasswordSubmit = lazy(
  () => import("./auth/pages/ForgotPasswordSubmit")
);
const Login = lazy(() => import("./auth/pages/Login"));
// const Register = lazy(() => import("./auth/pages/Register"));

// Calendar
const CalendarApp = lazy(() => import("./calendar/pages/CalendarApp"));

// Core
const Forbidden = lazy(() => import("./core/pages/Forbidden"));
const NotFound = lazy(() => import("./core/pages/NotFound"));
const UnderConstructions = lazy(
  () => import("./core/pages/UnderConstructions")
);

// Landing
const Landing = lazy(() => import("./landing/pages/Landing"));

// Users
const UserManagement = lazy(() => import("./users/pages/UserManagement"));
const ReliablityGrowth = lazy(
  () => import("./admin/pages/qualityai/ReliablityGrowth")
);

// AI Chat
const AIChat = lazy(() => import("./admin/pages/connectai/AIChat"));

// Quality AI
// const Quality = lazy(() => import("./admin/pages/qualityai/Quality"));
const PFDI = lazy((() => import("./admin/pages/qualityai/PredictionFailureDefectionIdentification")));
const MFC = lazy(() => import("./admin/pages/qualityai/MachineFailureCluster"));
const NHTSC = lazy(() => import("./admin/pages/qualityai/NHTSC"));
const DRA = lazy(
  () =>
    import("./admin/pages/qualityai/partsFailureAnalysis/DefectRateAnalysis")
);
const DLA = lazy(
  () => import("./admin/pages/qualityai/partsFailureAnalysis/DefectByUnitLife")
);
const ZS = lazy(
  () => import("./admin/pages/qualityai/partsFailureAnalysis/Zscore")
);
const PA = lazy(() => import("./admin/pages/qualityai/ParetoAnalysis"));
const EWA = lazy(() => import("./admin/pages/qualityai/EarlyWarningAnalysis"));
const SMFC = lazy(() => import("./admin/pages/qualityai/mfc/SearchMFC"))
const NTF = lazy(() => import("./admin/pages/qualityai/NTFAnalysis"));
const MISA = lazy(() => import("./admin/pages/qualityai/MISA"));
const RTA = lazy(
  () => import("./admin/pages/qualityai/qualityMetrics/RTrendAnalysis")
);
const FA = lazy(() => import("./admin/pages/qualityai/FailureAnalysis"));
const COA = lazy(() => import("./admin/pages/qualityai/CostOfQuality"));
const Webibull = lazy(() => import("./admin/pages/qualityai/Weibull"));
const WebibullAnalysis = lazy(() => import("./admin/pages/qualityai/WeibullAnalysis"));
const EWS = lazy(() => import("./admin/pages/qualityai/mfc/EarlyWarningSystem"));
const TC = lazy(() => import("./admin/pages/qualityai/TechnicianComment"));
const TBE = lazy(() => import("./admin/pages/qualityai/TrendByExposure"));
const TMFC = lazy(() => import("./admin/pages/qualityai/TopMFC"));
const CMFC = lazy(() => import("./admin/pages/qualityai/mfc/CreateMFC"));
const TireTreadAnalysis = lazy(() => import("./admin/pages/qualityai/TireTreadAnalysis"));
const SentiA = lazy(() => import("./admin/pages/warrantyai/SentimentAnalysis"));
const NLPIssues = lazy(() => import("./admin/pages/qualityai/mfc/NLPIssues"));
const IOTIssues = lazy(() => import("./admin/pages/qualityai/mfc/IOTIssues"));

// Warranty AI
const AP = lazy(() => import("./admin/pages/warrantyai/AnalystPerformance"));
const CCT = lazy(() => import("./admin/pages/warrantyai/ClaimCycleTime"));
const CF = lazy(() => import("./admin/pages/warrantyai/ClaimForecast"));
const CR = lazy(() => import("./admin/pages/warrantyai/ClaimReport"));
const DA = lazy(() => import("./admin/pages/warrantyai/DealerAnalysis"));
const NPC = lazy(() => import("./admin/pages/warrantyai/NetPromoterScore"));
const PRA = lazy(() => import("./admin/pages/warrantyai/PartReturnAnalysis"));
const SR = lazy(() => import("./admin/pages/warrantyai/SupplierRecovery"));
const WC = lazy(() => import("./admin/pages/warrantyai/WarrantyCluster"));
const WP = lazy(() => import("./admin/pages/warrantyai/WarrantyPayout"));
const WR = lazy(() => import("./admin/pages/warrantyai/WarrantyRegistration"));
const FHM = lazy(
  () => import("./admin/pages/warrantyai/SuspectClaims/FeatureHeatMap")
);
const SRM = lazy(
  () => import("./admin/pages/warrantyai/SuspectClaims/SuspectROI")
);
const SS = lazy(() => import("./admin/pages/warrantyai/SuspectClaims/Summary"));
const SC = lazy(() => import("./admin/pages/warrantyai/ServiceCampaign"));
const EW = lazy(() => import("./admin/pages/warrantyai/ExtendedWarranty"));
const WREPAIR = lazy(() => import("./admin/pages/warrantyai/WarrantyRepair"));
const PRSM = lazy(() => import("./admin/pages/warrantyai/PartsReturnStatusMetric"));
const WREJECCTION = lazy(() => import("./admin/pages/warrantyai/WarrantyRejection"));
const WCo = lazy(() => import("./admin/pages/warrantyai/CoPilot"));
const DCS = lazy(() => import("./admin/pages/warrantyai/DealerCertificationSummary"));
const DCD = lazy(() => import("./admin/pages/warrantyai/DealerCertificationDetails"));
const LOL = lazy(() => import("./admin/pages/warrantyai/LandoLakes"));
const ComputeReserve = lazy(() => import("./admin/pages/warrantyai/warrantyreserve/ComputeReserve"));
const ReserveIf = lazy(() => import("./admin/pages/warrantyai/warrantyreserve/ReserveWhatIf"));
const ReserveDashboard = lazy(() => import("./admin/pages/warrantyai/warrantyreserve/ReserveDashboard"));
const WR_CCT = lazy(() => import("./admin/pages/warrantyai/warrantyreserve/ClaimCycleTime"));
const WR_CD = lazy(() => import("./admin/pages/warrantyai/warrantyreserve/ClaimDashboard"));
const WR_DA = lazy(() => import("./admin/pages/warrantyai/warrantyreserve/DealerAnalysis"));
const WR_RCR = lazy(() => import("./admin/pages/warrantyai/warrantyreserve/RawClaimsReport"));
const WR_SCO = lazy(() => import("./admin/pages/warrantyai/warrantyreserve/SuspectedClaims"));
const WR_WC = lazy(() => import("./admin/pages/warrantyai/warrantyreserve/WarrantyCluster"));
const WR_WP = lazy(() => import("./admin/pages/warrantyai/warrantyreserve/WarrantyPayout"));
const WR_WR = lazy(() => import("./admin/pages/warrantyai/warrantyreserve/WarrantyRegistration"));
const WR_PA = lazy(() => import("./admin/pages/warrantyai/warrantyreserve/PayoutAnalysis"));
const WR_WE = lazy(() => import("./admin/pages/warrantyai/warrantyreserve/WarrantyExposure"));

// connect ai
const CAIO = lazy(() => import("./admin/pages/connectai/Overview"));
const AIA = lazy(() => import("./admin/pages/connectai/AIAlert"));
const IoTA = lazy(() => import("./admin/pages/connectai/IoTAlert"));
const FP = lazy(() => import("./admin/pages/connectai/Prediction"));
const AD = lazy(() => import("./admin/pages/connectai/AnomalyDetection"));
const HM = lazy(() => import("./admin/pages/connectai/HealthMonitoring"));
const EA = lazy(() => import("./admin/pages/connectai/ErrorAnalysis"));
const GF = lazy(() => import("./admin/pages/connectai/GeoFencing"));
const VAD = lazy(() => import("./admin/pages/connectai/ViewAlertDetails"));
const AM = lazy(() => import("./admin/pages/connectai/AssetMonitoring"));
const BR = lazy(() => import("./admin/pages/connectai/BusinessRules"));

//Field Service ai
const CS = lazy(
  () => import("./admin/pages/fieldserviceai/CustomerSatisfaction")
);
const FSA = lazy(() => import("./admin/pages/fieldserviceai/FieldServiceAI"));
const RP = lazy(
  () => import("./admin/pages/fieldserviceai/RevenueProfitability")
);
const PDF = lazy(
  () => import("./admin/pages/fieldserviceai/PartsDemandForcast")
);
const SDF = lazy(
  () => import("./admin/pages/fieldserviceai/ServiceDemandForcasting")
);
const TE = lazy(
  () => import("./admin/pages/fieldserviceai/TechnicianEfficiency")
);
const WOS = lazy(() => import("./admin/pages/fieldserviceai/WordOrderSummary"));

//Service Contract
const CP = lazy(
  () => import("./admin/pages/servicecontract/ContractPerformance")
);
const CRE = lazy(() => import("./admin/pages/servicecontract/ContractRenewal"));
const CRA = lazy(
  () => import("./admin/pages/servicecontract/ContractAcquisition")
);
const CRAC = lazy(
  () => import("./admin/pages/servicecontract/ContractProfitabilityComparison")
);
const CRACD = lazy(
  () => import("./admin/pages/servicecontract/ContractProfitability")
);
const SLAPerformance = lazy(
  () => import("./admin/pages/servicecontract/SLAPerformance")
);
const VP = lazy(
  () => import("./admin/pages/servicecontract/VendorPerformance")
);
const REP = lazy(
  () => import("./admin/pages/servicecontract/RevenueAndProfitability")
);
const SCP = lazy(() => import("./admin/pages/servicecontract/ContractPricing"));
const FD = lazy(
  () => import("./admin/pages/servicecontract/FinancialDashboard")
);

//parts price
const AWMCC = lazy(
  () => import("./admin/pages/partpricing/AnalysisWithMultipleCostCategory")
);
const CEA = lazy(() => import("./admin/pages/partpricing/CompetitiveAnalysis"));
const CVPA = lazy(
  () => import("./admin/pages/partpricing/CostVariationProfitAnalysis")
);
const CVSPA = lazy(
  () => import("./admin/pages/partpricing/CostVariationSalesProfitAnalysis")
);
const CA = lazy(() => import("./admin/pages/partpricing/CustomerAnalysis"));
const OAP = lazy(
  () => import("./admin/pages/partpricing/OverAllProfitAnalysis")
);
const PSA = lazy(() => import("./admin/pages/partpricing/PartSalesAnalysis"));
const PABS = lazy(
  () => import("./admin/pages/partpricing/ProfitAnalysisByCustomerSegmentation")
);
const PBS = lazy(
  () => import("./admin/pages/partpricing/ProfitAnalysisByItemSegment")
);
const PBI = lazy(
  () => import("./admin/pages/partpricing/ProfitAnalysisByItem")
);
const PSB = lazy(
  () => import("./admin/pages/partpricing/ProfitAnalysisBySupplier")
);
const PDFP = lazy(
  () => import("./admin/pages/partpricing/PartsDemandForecasting")
);
const PEA = lazy(
  () => import("./admin/pages/partpricing/PromoEffectivenessAnalysis")
);
const PR = lazy(() => import("./admin/pages/partpricing/PromoRecommendation"));
const CAR = lazy(() => import("./admin/pages/partpricing/ClusterAnalysis"));
const PP = lazy(() => import("./admin/pages/partpricing/PartPriceGPT"));
const COMFORTSYSTEM = lazy(() => import("./admin/pages/partpricing/ComfortSystem"));

//Konwledge

const KCH = lazy(() => import("./admin/pages/knowledge/KnowledgeChat"));
const KDL = lazy(() => import("./admin/pages/knowledge/DataLoader"));
const KU = lazy(() => import("./admin/pages/knowledge/Users"));
const KP = lazy(() => import("./admin/pages/knowledge/Projects"));
const KA = lazy(() => import("./admin/pages/knowledge/Admin"));
const KCU = lazy(() => import("./admin/pages/knowledge/CreateUser"));
const KCP = lazy(() => import("./admin/pages/knowledge/CreateProject"));
const TB = lazy(() => import("./admin/pages/knowledge/triageBot/TriageBot"));
const FB = lazy(() => import("./admin/pages/knowledge/triageBot/Feedback"));
const AssetResult = lazy(() => import("./admin/pages/knowledge/Asset360"));
const DG = lazy(() => import("./admin/pages/knowledge/DocumentGeneration"));

const NewAdmin = lazy(() => import("./admin/pages/AdminNew"));

// Field Service
const FAC = lazy(() => import("./admin/pages/FieldServiceApp/Customers"));
const FACases = lazy(() => import("./admin/pages/FieldServiceApp/Cases"));
const FAWorkOrders = lazy(() => import("./admin/pages/FieldServiceApp/WorkOrders"));
const FADC = lazy(() => import("./admin/pages/FieldServiceApp/DispatcherConsole"));
const FACh = lazy(() => import("./admin/pages/FieldServiceApp/Chat"));
const FACase = lazy(() => import("./admin/pages/FieldServiceApp/CaseView"));
const FAWorkOrder = lazy(() => import("./admin/pages/FieldServiceApp/WorkOrderView"));
const FACC = lazy(() => import("./admin/pages/FieldServiceApp/CreateCase"));
const FACW = lazy(() => import("./admin/pages/FieldServiceApp/CreateWorkOrder"));
 

const AppRoutes = () => {
  return (
    <Routes basename={process.env.PUBLIC_URL}>
      <Route path="/landing" element={<Landing />} />
      <PrivateRoute path="admin" element={<NewAdmin />}>
        {/* <PrivateRoute path="/" element={<Home />} /> */}
        <PrivateRoute path="search" element={<Search />} />
        <PrivateRoute path="overview" element={<Overview />} />
        <PrivateRoute path="ai-chatboats" element={<CalendarApp />} />
        <PrivateRoute path="recommendation" element={<Dashboard />} />
        <PrivateRoute path="faq" element={<Faq />} />
        <PrivateRoute path="help" element={<HelpCenter />} />
        <PrivateRoute path="profile" element={<Profile />}>
          <PrivateRoute path="/" element={<ProfileActivity />} />
          <PrivateRoute path="information" element={<ProfileInformation />} />
          <PrivateRoute path="password" element={<ProfilePassword />} />
        </PrivateRoute>

        {/* Field Service App */}
        <PrivateRoute path="field-service-app">
          <PrivateRoute path="customers" element={<FAC />} />
          <PrivateRoute path="cases" element={<FACases />} />
          <PrivateRoute path="work-orders" element={<FAWorkOrders />} />
          <PrivateRoute path="dispatcher-console" element={<FADC />} />
          <PrivateRoute path="chat/:SessionID" element={<FACh />} />
          <PrivateRoute path="case/:CaseID" element={<FACase />} />
          <PrivateRoute path="work-order/:WorkOrderID" element={<FAWorkOrder recommendationData={undefined} caseData={undefined} onClickBack={function (): void {
            throw new Error("Function not implemented.");
          } } appiontmentDataList={undefined} appointementTotalRecords={0} appiontmentFilters={undefined} setAppiontmentFiltes={undefined} />} />
          <PrivateRoute path="create-case" element={<FACC />} />
          <PrivateRoute path="create-work-order" element={<FACW onClickBack={function () {
            throw new Error("Function not implemented.");
          } } />} />
        </PrivateRoute>

        {/* <PrivateRoute path="quality" element={<Quality /> } /> */}
        <PrivateRoute path="quality/defect-identification" element={<PFDI />} />

        <PrivateRoute path="quality/nhtsa" element={<NHTSC />} />
        <PrivateRoute
          path="quality/reliablity-growth"
          element={<ReliablityGrowth />}
        />
        <PrivateRoute
          path="quality/reliablity-growth/weibull-survival-analysis"
          element={<Webibull />}
        />
        <PrivateRoute path="quality/mfc" element={<MFC />} />
        <PrivateRoute path="quality/early-warning-system/trending-quality-issues" element={<EWS />} />
        <PrivateRoute path="quality/early-warning-system/create-mfc" element={<CMFC />} />
        <PrivateRoute path="quality/early-warning-system/nlp-issues" element={<NLPIssues />} />
        <PrivateRoute path="quality/early-warning-system/iot-issues" element={<IOTIssues />} />
        <PrivateRoute path="quality/early-warning-system/search-quality-issues" element={<SMFC />} />
        <PrivateRoute
          path="quality/pfa/defect-rate-analysis"
          element={<DRA />}
        />
        <PrivateRoute
          path="quality/pfa/defect-by-unit-life"
          element={<DLA />}
        />
        <PrivateRoute path="quality/pfa/z-score" element={<ZS />} />
        <PrivateRoute path="quality/pareto-analysis" element={<PA />} />
        <PrivateRoute path="quality/early-warning-analysis" element={<EWA />} />
        <PrivateRoute
          path="quality/no-trouble-found-analysis"
          element={<NTF />}
        />
        <PrivateRoute path="quality/misa" element={<MISA />} />
        <PrivateRoute
          path="quality/metrics/r-1000-trend-analysis"
          element={<RTA />}
        />
        <PrivateRoute path="quality/webibull-analysis" element={<WebibullAnalysis />} />
        <PrivateRoute path="quality/failure-analysis" element={<FA />} />
        <PrivateRoute path="quality/cost-quality" element={<COA />} />
        <PrivateRoute path="quality/technician-comment" element={<TC />} />
        <PrivateRoute path="quality/trend-exposure" element={<TBE />} />
        <PrivateRoute path="quality/tire-tread-analysis" element={<TireTreadAnalysis />} />
        <PrivateRoute path="quality/top-mfc" element={<TMFC />} />
        <PrivateRoute path="quality/sentiment-analysis" element={<SentiA />} />
        <PrivateRoute path="warranty/analyst-performance" element={<AP />} />
        <PrivateRoute path="warranty/claim-cycle-time" element={<CCT />} />
        <PrivateRoute path="warranty/warrantyreserve/claim-forecast" element={<CF />} />
        <PrivateRoute path="warranty/claim-report" element={<CR />} />
        <PrivateRoute path="warranty/dealer-analysis" element={<DA />} />
        <PrivateRoute path="warranty/net-promoter-score" element={<NPC />} />
        <PrivateRoute path="warranty/part-return-analysis" element={<PRA />} />
        <PrivateRoute path="warranty/supplier-recovery" element={<SR />} />
        <PrivateRoute path="warranty/warranty-cluster" element={<WC />} />
        <PrivateRoute path="warranty/warranty-payout" element={<WP />} />
        <PrivateRoute path="warranty/warranty-registration" element={<WR />} />
        <PrivateRoute path="warranty/suspect-claims/summary" element={<SS />} />
        <PrivateRoute path="warranty/dealer-certification-summary" element={<DCS />} />
        <PrivateRoute path="warranty/dealer-certification-details" element={<DCD />} />
        <PrivateRoute path="warranty/copilot" element={<WCo />} />
        <PrivateRoute path="warranty/lando-lakes" element={<LOL />} />
        <PrivateRoute
          path="warranty/suspect-claims/suspect-roi"
          element={<SRM />}
        />
        <PrivateRoute
          path="warranty/suspect-claims/feature-heat-map"
          element={<FHM />}
        />
        <PrivateRoute path="warranty/service-campaign" element={<SC />} />
        <PrivateRoute path="warranty/extended-warranty" element={<EW />} />
        <PrivateRoute path="warranty/warranty-rejection" element={<WREJECCTION />} />
        <PrivateRoute path="warranty/warranty-repair" element={<WREPAIR />} />
        <PrivateRoute path="warranty/parts-return-status-metric" element={<PRSM />} />
        <PrivateRoute path="warranty/compute-reserve" element={<ComputeReserve />} />
        <PrivateRoute path="warranty/reserveif" element={<ReserveIf />} />
        <PrivateRoute path="warranty/reserve-dashboard" element={<ReserveDashboard />} />

        <PrivateRoute path="warranty/warrantyreserve/claim-cycle-time" element={<WR_CCT />} />
        <PrivateRoute path="warranty/warrantyreserve/claim-dashboard" element={<WR_CD />} />
        <PrivateRoute path="warranty/warrantyreserve/dealer-analysis" element={<WR_DA />} />
        <PrivateRoute path="warranty/warrantyreserve/raw-claims-report" element={<WR_RCR />} />
        <PrivateRoute path="warranty/warrantyreserve/suspected-claims-overview" element={<WR_SCO />} />
        <PrivateRoute path="warranty/warrantyreserve/warranty-cluster" element={<WR_WC />} />
        <PrivateRoute path="warranty/warrantyreserve/warranty-payout" element={<WR_WP />} />
        <PrivateRoute path="warranty/warrantyreserve/warranty-registration" element={<WR_WR />} />
        <PrivateRoute path="warranty/warrantyreserve/payout-analysis" element={<WR_PA />} />
        <PrivateRoute path="warranty/warrantyreserve/warranty-exposure" element={<WR_WE />} />

        <PrivateRoute path="connectai/overview" element={<CAIO />} />
        <PrivateRoute path="connectai/ai-alert" element={<AIA />} />
        <PrivateRoute path="connectai/iot-alert" element={<IoTA />} />
        <PrivateRoute path="connectai/prediction" element={<FP />} />
        <PrivateRoute path="connectai/anomaly-detecion" element={<AD />} />
        <PrivateRoute path="connectai/health-monitoring" element={<HM />} />
        <PrivateRoute path="connectai/asset-monitoring" element={<AM />} />
        <PrivateRoute path="connectai/error-analysis" element={<EA />} />
        <PrivateRoute path="connectai/geo-fencing" element={<GF />} />
        <PrivateRoute path="connectai/business-rules" element={<BR />} />
        <PrivateRoute path="connectai/aichat" element={<AIChat />} />
        <PrivateRoute
          path="field-service/customer-satisfaction"
          element={<CS />}
        />
        <PrivateRoute
          path="field-service/overall-performance"
          element={<FSA />}
        />
        <PrivateRoute
          path="field-service/revenue-profitability"
          element={<RP />}
        />
        <PrivateRoute
          path="field-service/parts-demand-forcasting"
          element={<PDF />}
        />
        <PrivateRoute
          path="field-service/service-demand-forcasting"
          element={<SDF />}
        />
        <PrivateRoute
          path="field-service/technician-efficiency"
          element={<TE />}
        />
        <PrivateRoute
          path="field-service/wordorder-summary"
          element={<WOS />}
        />
        <PrivateRoute
          path="service-contract/contract-performance"
          element={<CP />}
        />
        <PrivateRoute
          path="service-contract/contract-renewal"
          element={<CRE />}
        />
        <PrivateRoute
          path="service-contract/contract-acquisition"
          element={<CRA />}
        />
        <PrivateRoute
          path="service-contract/contract-profitability-comparison"
          element={<CRAC />}
        />
        <PrivateRoute
          path="service-contract/contract-profitability"
          element={<CRACD />}
        />
        <PrivateRoute
          path="service-contract/sla-performance"
          element={<SLAPerformance />}
        />
        <PrivateRoute
          path="service-contract/vendor-performance"
          element={<VP />}
        />
        <PrivateRoute
          path="service-contract/revenue-profitability"
          element={<REP />}
        />
        <PrivateRoute
          path="service-contract/financial-dashboard"
          element={<FD />}
        />
        <PrivateRoute
          path="service-contract/contract-pricing"
          element={<SCP />}
        />
        <PrivateRoute
          path="part-pricing/analysis-multiple-cost-category"
          element={<AWMCC />}
        />
        <PrivateRoute
          path="part-pricing/competitive-analysis"
          element={<CEA />}
        />
        <PrivateRoute
          path="part-pricing/cost-variation-profit-analysis"
          element={<CVPA />}
        />
        <PrivateRoute
          path="part-pricing/cost-variation-sales-profit-analysis"
          element={<CVSPA />}
        />
        <PrivateRoute path="part-pricing/customer-analysis" element={<CA />} />
        <PrivateRoute
          path="part-pricing/over-all-profit-analysis"
          element={<OAP />}
        />
        <PrivateRoute
          path="part-pricing/part-sales-analysis"
          element={<PSA />}
        />
        <PrivateRoute
          path="part-pricing/profit-analysis-customer-segmentation"
          element={<PABS />}
        />
        s
        <PrivateRoute
          path="part-pricing/profit-analysis-item-segment"
          element={<PBS />}
        />
        <PrivateRoute
          path="part-pricing/profit-analysis-item"
          element={<PBI />}
        />
        <PrivateRoute
          path="part-pricing/profit-analysis-supplier"
          element={<PSB />}
        />
        <PrivateRoute
          path="part-pricing/parts-demand-forecasting"
          element={<PDFP />}
        />
        <PrivateRoute
          path="part-pricing/promo-effectiveness-analysis"
          element={<PEA />}
        />
        <PrivateRoute
          path="part-pricing/promo-recommendation"
          element={<PR />}
        />
        <PrivateRoute path="part-pricing/cluster-analysis" element={<CAR />} />
        <PrivateRoute path="part-pricing/part-pricing" element={<PP />} />
        <PrivateRoute path="part-pricing/comfort-system" element={<COMFORTSYSTEM />} />

        <PrivateRoute path="knowledge/knowledge-chat" element={<KCH />} />
        <PrivateRoute path="knowledge/triage-search" element={<TB />} />
        <PrivateRoute path="knowledge/triage/feedback" element={<FB />} />
        <PrivateRoute path="knowledge/data-loader" element={<KDL />} />
        <PrivateRoute path="knowledge/users" element={<KU />} />
        <PrivateRoute path="knowledge/projects" element={<KP />} />
        <PrivateRoute path="knowledge/admin" element={<KA />} />
        <PrivateRoute path="knowledge/create-user" element={<KCU />} />
        <PrivateRoute path="knowledge/create-project" element={<KCP />} />
        <PrivateRoute path="knowledge/asset-360" element={<AssetResult />} />
        <PrivateRoute path="knowledge/knowledge-chat" element={<KCH />}/>
        <PrivateRoute path="knowledge/triage-search" element={<TB />}/>
        <PrivateRoute path="knowledge/triage/feedback" element={<FB />}/>
        <PrivateRoute path="knowledge/data-loader" element={<KDL />}/>
        <PrivateRoute path="knowledge/users" element={<KU />}/>
        <PrivateRoute path="knowledge/projects" element={<KP />}/>
        <PrivateRoute path="knowledge/admin" element={<KA />}/>
        <PrivateRoute path="knowledge/create-user" element={<KCU />}/>
        <PrivateRoute path="knowledge/create-project" element={<KCP />}/>
        <PrivateRoute path="knowledge/document-generation" element={<DG />}/>
        {/* <PrivateRoute path="knowledge/asset-360" element={<AssetResult />} /> */}

        <PrivateRoute
          path="connectai/view-alert-details/:ieminumber"
          element={<VAD />}
        />
        <PrivateRoute
          path="projects"
          element={
            <Navigate
              to={`/${process.env.PUBLIC_URL}/under-construction`}
              replace
            />
          }
        />
        <PrivateRoute path="sentiment-analysis" element={<UserManagement />} />


      </PrivateRoute>
      <Route path="forgot-password" element={<ForgotPassword />} />
      <Route path="forgot-password-submit" element={<ForgotPasswordSubmit />} />
      <Route path="/" element={<Login />} />
      {/* <Route path="register" element={<Register />} /> */}
      <Route path="under-construction" element={<UnderConstructions />} />
      <Route path="403" element={<Forbidden />} />
      <Route path="404" element={<NotFound />} />
      <Route
        path="*"
        element={<Navigate to={`/${process.env.PUBLIC_URL}/404`} replace />}
      />
    </Routes>
  );
};

export default AppRoutes;
